import type { LoaderFunctionArgs } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { BlogTimeline } from "~/components/BlogTimeline/BlogTimeline";
import { type Frontmatter, getPosts } from "~/utils/blog_post.server";

export async function loader(data: LoaderFunctionArgs) {
	const posts = await getPosts();
	return posts;
}

export default function Index() {
	const data =
		useLoaderData<
			Array<{
				slug: string;
				frontmatter: Frontmatter;
			}>
		>();
	return (
		<div style={{ fontFamily: "system-ui, sans-serif", lineHeight: "1.8" }}>
			<h1>Diffrient Thoughts</h1>
			<BlogTimeline posts={data} />
		</div>
	);
}
